/* eslint-disable react/jsx-props-no-spreading */
import { getComponentFromName } from '../../lib/utils';

import * as PopupComponents from '../popups';
import PopupDefault from '../popups/DefaultPopup';

interface PopupProps {
    className?: string;
    popup?: {
        popup: {
            component: string;
        };
    };
    onClose?: () => void;
}

function Popup({ className = null, popup = null, ...props }: PopupProps) {
    const { popup: popupObject } = popup || {};
    const { component = null } = popupObject || {};
    const Popup = getComponentFromName(PopupComponents, component, PopupDefault) || null;
    return Popup !== null ? <Popup className={className} {...props} {...popup} /> : null;
}

export default Popup;
